import { CONSTANTS } from "src/app/constants";
import { ModelWithUnitsOfMeasure } from "src/app/providers/utils/uom";
import { IMission } from "../interfaces/mission.interface";
import { ProductMission } from "./product-mission.model";
import { Uom } from "./uom.model";

const { CONFIG_STATUS } = CONSTANTS.MISSION;

export class Mission extends ModelWithUnitsOfMeasure implements IMission {
    missionId: string;
    missionName: string;
    missionEstimatedStartDate: number;
    missionEstimatedEndDate: number;
    DMDSExpectedMinFlowrate: number;
    DMDSExpectedMaxFlowrate: number;
    materialstatus: number;
    productstatus: number;
    teamstatus: number;
    supportstatus: number;
    globalstatus: number;
    marketname: string;
    unitDMDSInjectionPointPressure: number;
    unitName: string;
    unitypeName: string;
    refineryName: string;
    refineryGPS: string;
    siteWellawareId: string;
    catalystWeight: number;
    catalystProvider: string;
    catalystproviderName: string;
    catalystName: string;
    catalystStoechioSulfur: number;
    catalystStoechioDMDS: number;
    feedstocknatureName: string;
    feedstockFlowrate: number;
    feedstockSulfurcontent: number;
    feedstockRecycling: number;
    H2Recycling: number;
    unitWorkingPressure: number;
    H2Flowrate: number;
    
    products: ProductMission[];

    constructor(mission: IMission) {        
        const uoms = mission.uoms.map(uom => new Uom(uom));
        super(uoms);
        Object.keys(mission).map(key => this[key] = mission[key]);
        this.products = mission.products.map(product => new ProductMission(product));
    }

    get status(): number {
        if (this.globalstatus > CONFIG_STATUS.READY_FOR_CHECKING) {
            return CONFIG_STATUS.BLOCKED;
        }
        
        const statusList = [this.materialstatus, this.productstatus, this.teamstatus, this.supportstatus];
        const statusMin = Math.min(...statusList);
        const statusMax = Math.max(...statusList);

        return statusMax < CONFIG_STATUS.COMPLETED ? statusMax :
                statusMin >= CONFIG_STATUS.COMPLETED ? statusMin :
                CONFIG_STATUS.IN_PROGRESS;
    }

    get checkingIsDone(): boolean {
        return this.globalstatus > CONFIG_STATUS.READY_FOR_CHECKING;
    }

    get estimatedDuration(): string {
      const duration = this.missionEstimatedEndDate - this.missionEstimatedStartDate;
      const durationInHours = duration / (60 * 60);
      return Math.trunc(durationInHours) + ' h';
    }

    getCoordinates(): [number, number] {
        if (!this.refineryGPS) {
            return [null, null];
        }
        const coordinates = this.refineryGPS.replace(/ /g, '')
                                            .split(',')
                                            .map((coord: string) => parseFloat(coord));
        return [coordinates[1], coordinates[0]];
    }

    hasCoordinates(coordinates: [number, number]): boolean {
        const missionCoordinates = this.getCoordinates();
        return missionCoordinates[0] === coordinates[0] &&
                missionCoordinates[1] === coordinates[1]
    }
}
